export default {
  title: 'SEND YOUR INQUIRY',
  flash: {
    title: 'Get in touch with us.',
    body: 'In case you still have questions, please contact us for additional information.'
  }
}